import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  items: ".animation--container > *",
  video: ".animation--video",
  videoCaption: ".animation--video-caption",
};

export default node => {
  // Add the animation delay offset variables
  delayOffset(node, [selectors.video, selectors.videoCaption]);
  delayOffset(node, [selectors.items], 6);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
